import React from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'

export interface LeftNavigationCollectionStatusesProps {
  subTotals: [number, number, number]
  colors: [string, string, string]
}

const CollectionStatuses = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 38px;
  height: 25px;
`

const CollectionStatusInfo = styled.div`
  width: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const StatusCircle = styled.div<{ color: string }>`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-right: 3px;
  background-color: ${props => props.color};
`

const StatusNumber = styled.div`
  font-family: ProximaNova;
  font-size: 12px;
  color: ${constants.CORE_PRIMARY_5};
}
`

const CollectionStatus: React.FunctionComponent<{ color: string; total: number }> = props => {
  const { color, total } = props
  return (
    <CollectionStatusInfo>
      <StatusCircle color={color} />
      <StatusNumber>{total}</StatusNumber>
    </CollectionStatusInfo>
  )
}

export const LeftNavigationCollectionStatuses: React.FunctionComponent<LeftNavigationCollectionStatusesProps> = props => {
  const { subTotals, colors } = props

  return (
    <CollectionStatuses>
      {subTotals.map((subTotal, index) => (
        <CollectionStatus key={index} color={colors[index]} total={subTotal} />
      ))}
    </CollectionStatuses>
  )
}
